module.exports = __webpack_public_path__ + "img/signup-v1.4f4a5d53.jpg";